'use client'

import Link from 'next/link'
import React from 'react'
import type { Header } from '@/payload-types'
import { Logo } from '@/components/Logo/Logo'
import { DesktopNav } from './DesktopNav'
import { MobileNav } from './MobileNav'
import { IconNavItems } from './IconNavItems'

interface Props {
  data: Header
}

export const HeaderClient: React.FC<Props> = ({ data }) => {
  return (
    <header className="sticky z-30 bg-paper-2 top-0 drop-shadow-xs">
      <div className="container px-4 mx-auto relative z-20 flex items-center justify-between h-20">
        <Link href="/">
          <Logo loading="eager" priority="high" className="h-10" />
        </Link>
        <div className="hidden lg:flex flex-1 h-full w-full">
          <DesktopNav data={data} />
        </div>
        <div className="flex gap-[50px] items-center">
          <div className="hidden md:flex gap-[50px] items-center">
            <IconNavItems />
          </div>
          <div className="pr-[10px] md:pr-0 flex lg:hidden items-center">
            <MobileNav data={data} />
          </div>
        </div>
      </div>
    </header>
  )
}
